module.exports = __webpack_public_path__ + "img/storage_white.986205c7.png";